// src/features/cart/components/AddToCart.jsx
import React from 'react';
import { ShoppingCart } from 'react-feather';
import { useAddToCart } from '../api/addToCart';
import { useAuth } from 'lib/auth';
import { useNavigate } from 'react-router-dom';

export const AddToCart = ({ productId, quantity = 1 }) => {
  const addToCartMutation = useAddToCart();

  const { user } = useAuth();

  const navigate = useNavigate();

  const handleAddToCart = async () => {
    try {
      await addToCartMutation.mutateAsync({ product: productId, quantity });
    } catch (err) {
      console.error('Add to cart failed:', err);
    }
  };

  return (
    <>
      {user ? (
        <button
          onClick={handleAddToCart}
          disabled={addToCartMutation.isLoading}
          className="bg-[#AC3F1E] text-white uppercase tracking-wide px-6 py-3 font-semibold hover:opacity-90 transition flex items-center gap-2 rounded-md shadow-sm disabled:opacity-60"
        >
          <ShoppingCart size={18} />
          {addToCartMutation.isLoading ? 'Adding...' : 'Add to Cart'}
        </button>
      ) : (
        <button
          onClick={() => navigate('/account/login')}
          className="bg-[#AC3F1E] text-white uppercase tracking-wide px-6 py-3 font-semibold hover:opacity-90 transition flex items-center gap-2 rounded-md shadow-sm disabled:opacity-60"
        >
          <ShoppingCart size={18} />
          Login to purchase
        </button>
      )}
    </>
  );
};
